import AuthenticationManager from './AuthenticationManager';

import { warning } from '../Notifications/notice';

// Just to make this easier
export const AUTH_STATUS = {
    error: 'USER_AUTHENTICATION_FAILED',
    not: 'USER_NOT_AUTHENTICATED',
    inprogress: 'USER_AUTHENTICATION_IN_PROGRESS',
    ok: 'USER_AUTHENTICATED',
};

export default class AuthenticationService {
    constructor(jokiInstance) {
        this.headers = null;
        this.authData = null;
        this.authenticationStatus = 'not';
        this.joki = jokiInstance;
        this.serviceId = 'AuthenticationService';
        this.joki.addService({
            id: this.serviceId,
            fn: this.messageHandler.bind(this),
        });

        this.initCallSent = false;

        this.expireEvent = null;
    }

    messageHandler(event) {
        // console.log("AuthenticationService:Message Handler", event);

        switch (event.key) {
            case 'login':
                this.login();
                break;
            case 'logout':
                this.logout();
                break;
            case 'renew':
                this._oicdRenew();
                break;
            case 'headers':
                if (this.headers === null) {
                    return null;
                }
                return { ...this.headers };
            case 'getStatus':
                return AUTH_STATUS[this.authenticationStatus];
            case 'getAuthData':
                return this._getAuthData();
            default:
                break;
        }
    }

    login() {
        this._oicdRedirectToLogin();
    }

    // TODO: This does not work.
    logout() {
        this._oicdRedirectLogout();
        // warning("Logout does not work at the moment");
        this.joki.broadcast({
            from: this.serviceId,
            key: 'logout',
        });
    }

    _getAuthData() {
        if (this.authData === null) {
            return null;
        }
        if (this.authData.expired) {
            if (this.authenticationStatus !== 'error') {
                this._triggerStatusChange('error');
            }
            return null;
        }
        return this.authData;
    }

    _triggerStatusChange(changeStatus) {
        this.authenticationStatus = changeStatus;
        this.joki.broadcast({
            from: this.serviceId,
            key: 'AuthenticationStatusChanged',
            body: AUTH_STATUS[this.authenticationStatus],
        });
    }

    _oicdRedirectToLogin() {
        this._triggerStatusChange('inprogress');
        AuthenticationManager.signinRedirect();
    }

    _oicdRedirectLogout() {
        this._triggerStatusChange('error');
        AuthenticationManager.signoutRedirect();
    }

    _oicdRenew() {
        this._triggerStatusChange('inprogress');
        AuthenticationManager.getUser()
            .then(authData => {
                if (!authData) {
                    this._triggerStatusChange('error');
                    return;
                }
                this.authData = authData;

                // console.log("Login ok\n", this.authData.expires_at, "\n", Math.round(Date.now()/1000), "\n", twoMinutes, "\n");

                this._triggerStatusChange('ok');
                this._createExpireEvent();
                this.joki.initServices();

                return authData;
            })
            .catch(err => {
                console.warn('ERROR', err);
            });
    }

    _createExpireEvent() {
        if (this.authData !== null && this.expireEvent === null) {
            const msTillExpire = this.authData.expires_in * 1000;
            const msTillReminder = (this.authData.expires_in - 300) * 1000;

            this.expireEvent = {};

            if (msTillReminder < 0) {
                const sessionDoomClock =
                    this.authData.expires_in > 60 ? `${Math.floor(this.authData.expires_in / 60)} minutes` : `${this.authData.expires_in} seconds`;
                this.expireEvent['reminder'] = setTimeout(() => {
                    warning(`Session will die in ${sessionDoomClock}`);
                }, msTillReminder);
            } else {
                this.expireEvent['reminder'] = setTimeout(() => {
                    warning('Session will die in 5 minutes');
                }, msTillReminder);
            }

            this.expireEvent['expires'] = setTimeout(() => {
                // critical("Session has been closed! Please refresh your browser window to login again.");
                this.joki.broadcast({
                    from: this.serviceId,
                    key: 'sessionHasDied',
                });
            }, msTillExpire);
        }
    }
}
